import { FC, useEffect } from 'react';

import { Container } from '@mui/material';

import BankIdUserData from 'src/components/auth/BankIdUserData';
import CustomerDataLoading from 'src/components/loading/CustomerDataLoading';
import { useAuthContext } from 'src/contexts/auth/AuthContext';
import { useFormStepperDialogContext } from 'src/contexts/FormStepperDialogContext';
import useFetchEV from 'src/hooks/fetch/useFetchEV';
import useFetchGR from 'src/hooks/fetch/useFetchGR';
import useFetchMe from 'src/hooks/fetch/useFetchMe';
import ContactData from 'src/types/auth/ContactData';

import GrFirstAppCreatedPage from './GrFirstAppCreatedPage';
import GrFirstCredits from './GrFirstCredits';
import GrFirstStartPage from './GrFirstStartPage';

interface GrFirstProps { }

const GrFirst: FC<GrFirstProps> = (props) => {
  const { } = props;

  const { checkBankIdNoAuth, authState, authFinished } = useAuthContext();
  const { appIsCreated } = useFormStepperDialogContext();
  const { loading: fetchMeLoading, hasEmailAndPhone, dataLoaded: meDataLoaded } = useFetchMe();
  const { evDataLoaded, evDataLoading, fetchEVData } = useFetchEV();
  const { fetchGRData, grDataLoaded, grDataLoading } = useFetchGR();

  useEffect(() => {
    (async () => {
      if (authState?.authenticated && hasEmailAndPhone) {
        await fetchGRData();
        await fetchEVData();
      }
    })();
  }, [authState?.authenticated, hasEmailAndPhone]);

  useEffect(() => {
    checkBankIdNoAuth();
  }, []);

  const loading = fetchMeLoading || grDataLoading || evDataLoading;

  if (!authFinished) {
    return <></>;
  }

  return (
    <>
      {authState?.authenticated && (
        <>
          {appIsCreated && (
            <GrFirstAppCreatedPage />
          )}
          {!appIsCreated && (
            <>
              {loading && (
                <CustomerDataLoading />
              )}
              {!loading && grDataLoaded && evDataLoaded && hasEmailAndPhone && (
                <GrFirstCredits />
              )}
              {!loading && meDataLoaded && !hasEmailAndPhone && (
                <BankIdUserData
                  callback={async (data: ContactData) => {
                    await fetchGRData(data);
                    await fetchEVData(data);
                  }}
                />
              )}
            </>
          )}
        </>
      )}
      {!authState?.authenticated && (
        <Container
          maxWidth='sm'
          disableGutters
        >
          <GrFirstStartPage />
        </Container>
      )}
    </>
  );
};


export default GrFirst;
